/**
 * WordPress dependencies
 */
import {
	ToggleGroupControl,
	ToggleGroupControlOption,
} from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { T_SHIRT_ABBREVIATIONS, T_SHIRT_NAMES } from './constants';
import type { FontSizePickerToggleGroupProps } from './types';

const FontSizePickerToggleGroup = (
	props: FontSizePickerToggleGroupProps
): JSX.Element => {
	const {
		fontSizes,
		value,
		__next40pxDefaultSize,
		size,
		disabled,
		onChange,
	} = props;
	return (
		<ToggleGroupControl
			__nextHasNoMarginBottom
			__next40pxDefaultSize={ __next40pxDefaultSize }
			__shouldNotWarnDeprecated36pxSize
			label={ _x( 'Font size', 'text', 'nelio-ab-testing' ) }
			hideLabelFromVision
			disabled={ disabled }
			value={ value }
			onChange={ onChange }
			isBlock
			size={ size }
		>
			{ fontSizes.map( ( fontSize, index ) => (
				<ToggleGroupControlOption
					key={ fontSize.slug }
					value={ fontSize.size }
					disabled={ disabled }
					label={ T_SHIRT_ABBREVIATIONS[ index ] as string }
					aria-label={ fontSize.name || T_SHIRT_NAMES[ index ] }
					showTooltip
				/>
			) ) }
		</ToggleGroupControl>
	);
};

export default FontSizePickerToggleGroup;
